// src/SocietyMember/context/SocietyContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";
import {
  getMembers,
  getTasks,
  getMySocietyProfile,
} from "../../../api/societyRequest";

const SocietyContext = createContext();

export const SocietyProvider = ({ children }) => {
  const [members, setMembers] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [myRole, setMyRole] = useState(null);
  const [me, setMe] = useState(null);

  useEffect(() => {
    loadAll();
  }, []);

  const loadAll = async () => {
    const meRes = await getMySocietyProfile();
    setMe(meRes.data);
    setMyRole(meRes.data.role);

    const membersRes = await getMembers();
    setMembers(membersRes.data);

    const tasksRes = await getTasks();
    setTasks(tasksRes.data);
  };

  return (
    <SocietyContext.Provider
      value={{
        members,
        setMembers,
        tasks,
        setTasks,
        myRole,
        me,
      }}
    >
      {children}
    </SocietyContext.Provider>
  );
};

export const useSociety = () => useContext(SocietyContext);